function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { Row, Col } from 'reactstrap';
import Icon from "../common/icon";
import TranslateObj from "../common/translation-object";
import { useWorkFlow } from "../contexts/workflow";
var HeaderLayout = function HeaderLayout(props) {
  var currentBloc = props.currentBloc,
    blocs = props.blocs,
    isHidden = props.isHidden;
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    sortedBloc = _useState2[0],
    setSortedBlocs = _useState2[1];
  var _useWorkFlow = useWorkFlow(),
    collector = _useWorkFlow.collector;
  var compare = function compare(a, b) {
    // on trie seulement par le dernier chiffre
    var arrayA = a.order.split('.');
    var arrayB = b.order.split('.');
    var aOrder = parseInt(arrayA[arrayA.length - 1], 10);
    var bOrder = parseInt(arrayB[arrayB.length - 1], 10);
    if (aOrder === bOrder) {
      return 0;
    }
    return aOrder > bOrder ? 1 : -1;
  };
  /**
   * Format the diagnostic by order.
   */
  var sortBlocs = function sortBlocs(blocsToCompare) {
    blocsToCompare.sort(compare);
    setSortedBlocs(blocsToCompare);
  };
  useEffect(function () {
    if (!blocs) {
      return;
    }
    sortBlocs(_toConsumableArray(blocs));
  }, []);
  if (isHidden) {
    return null;
  }
  if (!sortedBloc) {
    return null;
  }
  var community = collector.diag ? collector.diag.community : {
    polygon: null,
    polygonColor: null
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "collectorHeader"
  }, /*#__PURE__*/React.createElement(Row, {
    className: "collectorHeaderRow"
  }, sortedBloc.map(function (bloc) {
    var isActive = currentBloc && bloc.id === currentBloc.id ? 'active' : null;
    var hasIcon = currentBloc && currentBloc.icon && currentBloc.icon !== '';
    if (bloc.headerDisplay !== undefined && bloc.headerDisplay !== null) {
      if (!bloc.headerDisplay) return null;
    }

    // Permet de le laisser apparant
    if (isActive) {
      bloc.displayConditions = [];
    }
    return /*#__PURE__*/React.createElement(Col, {
      className: "collectorCol ".concat(isActive),
      key: "bloc_".concat(Math.random())
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        position: 'relative'
      }
    }, !isActive ? null : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "mapMarker collectorMarker background"
    }, /*#__PURE__*/React.createElement(Icon, {
      name: "map-marker",
      className: "marker-bg text-white"
    })), /*#__PURE__*/React.createElement("div", {
      className: "collectorMarker"
    }, /*#__PURE__*/React.createElement("div", {
      className: "mapMarker collectorMarkerContainer d-flex justify-content-center"
    }, /*#__PURE__*/React.createElement(Icon, {
      name: "map-marker"
    }), !hasIcon ? null : /*#__PURE__*/React.createElement(Icon, {
      className: "inside-marker",
      name: currentBloc.icon
    }))), /*#__PURE__*/React.createElement("div", {
      className: "collectorBubble"
    })), /*#__PURE__*/React.createElement("span", {
      className: "collectorBlocName  ".concat(isActive === 'active' ? null : 'headerMenuText')
    }, /*#__PURE__*/React.createElement(TranslateObj, {
      from: bloc.name
    }))));
  })));
};
export default HeaderLayout;